import { useMemo } from "react";
import CardLabel from "./TaskCard/CardLabel";
import LoopIcon from "./TaskCard/icons/LoopIcon";
import CardStatusBadge from "./TaskCard/CardStatusBadge";
import CardAttemptsBadge from "./TaskCard/CardAttemptsBadge";
import DeleteButton from "./TaskCard/DeleteButton";

import { getCardVariant } from "./TaskCard/TaskCard";
// import { ADD_TASK_IN_DO_WHILE } from "pages/definition/state/taskModifier/constants";
import _isEmpty from "lodash/isEmpty";
import PlusIcon from "./TaskCard/icons/PlusIcon";

const DoWhileTask = ({
  nodeData,
  onToggleTaskMenu,
  isInconsistent,
}: {
  nodeData: any;
  onToggleTaskMenu: (event: any) => void;
  isInconsistent: boolean;
}) => {
  const { task } = nodeData;
  const { type } = task;

  const maybeAddButton = useMemo(
    () =>
      task.executionData == null && _isEmpty(task.loopOver) ? (
        <button
          onClick={(event) => {
            // onToggleTaskMenu(event, {
            //   id: `${task.taskReferenceName}_inner_do_while`,
            //   port: undefined,
            //   node: {
            //     data: { ...nodeData, action: ADD_TASK_IN_DO_WHILE },
            //   },
            // });
          }}
          style={{
            backgroundColor: "#ffffff",
          }}
        >
          <PlusIcon />
        </button>
      ) : null,
    [task, nodeData, onToggleTaskMenu]
  );

  return (
    <div
      style={{
        cursor: isInconsistent ? "not-allowed" : "pointer",
        display: "flex",
        width: "100%",
        padding: "20px",
        border: "1px dashed black",
        borderRadius: "20px",
        textAlign: "center",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        ...getCardVariant(type, nodeData.status, nodeData.selected),
        background: "rgba(0,50,100,.5)",
      }}
    >
      {/* Execution */}
      <CardStatusBadge status={nodeData.status} />
      {nodeData?.attempts > 1 ? (
        <CardAttemptsBadge attempts={nodeData.attempts} />
      ) : null}

      {/* Definition */}
      {/* <DeleteButton maybeHideData={nodeData} /> */}

      <div
        style={{
          position: "absolute",
          top: "10px",
          left: "10px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <LoopIcon size={24} color="white" />
        <div
          style={{
            paddingLeft: "6px",
            marginTop: "-2px",
            color: "white",
            textShadow: "0 1px 2px black",
          }}
        >
          {nodeData.task.name}
        </div>
      </div>
      <CardLabel type={nodeData.task.type} />
      {/* {maybeAddButton} */}
    </div>
  );
};

export default DoWhileTask;
